import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/rv/upload.svg'


const _withScopeId = n => (_pushScopeId("data-v-0b660972"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "download-con" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Historical Red Invoice Notice Readiness")
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "font_family icon-xiazai" }, null, -1))
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Template Download ")
const _hoisted_5 = { class: "border-style" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "ant-upload-drag-icon" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    class: "uploadIcon"
  })
], -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "ant-upload-text" }, [
  /*#__PURE__*/_createTextVNode(" Drag and drop to upload or "),
  /*#__PURE__*/_createElementVNode("span", { class: "blueFont" }, "browse for files")
], -1))
const _hoisted_8 = { class: "process-con" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Selected Files: ")
const _hoisted_10 = { class: "margin-style" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "process-title-style" }, "Total Process:", -1))
const _hoisted_12 = { class: "process-style" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = /*#__PURE__*/_createTextVNode("Complete")
const _hoisted_15 = { key: 1 }
const _hoisted_16 = { class: "size-style" }
const _hoisted_17 = { style: {"position":"relative","width":"100%","margin-top":"10px"} }
const _hoisted_18 = /*#__PURE__*/_createTextVNode("Browse")
const _hoisted_19 = /*#__PURE__*/_createTextVNode("Upload")
const _hoisted_20 = { style: {"position":"relative","width":"100%","margin-top":"20px"} }
const _hoisted_21 = { class: "d-f flex-d-c" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "History Date", -1))
const _hoisted_23 = { style: {"margin-top":"10px"} }
const _hoisted_24 = ["onClick"]
const _hoisted_25 = ["onClick"]
const _hoisted_26 = { class: "btn-control" }
const _hoisted_27 = /*#__PURE__*/_createTextVNode("Cancel")
const _hoisted_28 = /*#__PURE__*/_createTextVNode("Update")
const _hoisted_29 = /*#__PURE__*/_createTextVNode(" Tips ")
const _hoisted_30 = { class: "modal-txt" }
const _hoisted_31 = /*#__PURE__*/_createTextVNode("Cancel")
const _hoisted_32 = /*#__PURE__*/_createTextVNode("Download")
const _hoisted_33 = /*#__PURE__*/_createTextVNode(" Tips ")
const _hoisted_34 = { class: "modal-txt" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_upload_dragger = _resolveComponent("a-upload-dragger")!
  const _component_a_progress = _resolveComponent("a-progress")!
  const _component_CheckCircleOutlined = _resolveComponent("CheckCircleOutlined")!
  const _component_a_date_picker = _resolveComponent("a-date-picker")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_drawer = _resolveComponent("a-drawer")!
  const _component_ExclamationCircleOutlined = _resolveComponent("ExclamationCircleOutlined")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_a_drawer, {
      title: "Upload File",
      placement: "right",
      visible: _ctx._visible,
      "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => ((_ctx._visible) = $event)),
      width: "650"
    }, {
      default: _withCtx(() => [
        _createElementVNode("section", _hoisted_1, [
          _createVNode(_component_a_button, {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/historicalRedInvoice')))
          }, {
            default: _withCtx(() => [
              _hoisted_2
            ]),
            _: 1
          }),
          _createVNode(_component_a_button, {
            type: "link",
            class: "blueFont",
            onClick: _ctx.handleDownloadTemplate
          }, {
            default: _withCtx(() => [
              _hoisted_3,
              _hoisted_4
            ]),
            _: 1
          }, 8, ["onClick"])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _withDirectives(_createVNode(_component_a_upload_dragger, {
            name: "file",
            listType: "picture-card",
            showUploadList: false,
            multiple: false,
            "before-upload": _ctx.beforeUpload,
            customRequest: _ctx.uploadRequest
          }, {
            default: _withCtx(() => [
              _hoisted_6,
              _hoisted_7
            ]),
            _: 1
          }, 8, ["before-upload", "customRequest"]), [
            [_vShow, _ctx.uploadStatus === 'start']
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_8, [
            _createElementVNode("p", null, [
              _hoisted_9,
              _createElementVNode("strong", null, _toDisplayString(_ctx.curUploadFile.name), 1)
            ]),
            _createElementVNode("p", _hoisted_10, [
              _hoisted_11,
              _createElementVNode("span", _hoisted_12, [
                _createVNode(_component_a_progress, {
                  percent: _ctx.curPercent,
                  strokeColor: "#108ee9"
                }, null, 8, ["percent"]),
                (
                                _ctx.uploadStatus === 'checked' ||
                                    _ctx.uploadStatus === 'imported'
                            )
                  ? (_openBlock(), _createElementBlock("span", _hoisted_13, [
                      _createVNode(_component_CheckCircleOutlined, { style: {"color":"#108ee9"} }),
                      _hoisted_14
                    ]))
                  : (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(_ctx.curPercent) + "% done", 1)),
                _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.uploadFileSize), 1)
              ])
            ])
          ], 512), [
            [_vShow, _ctx.uploadStatus !== 'start']
          ])
        ]),
        _createElementVNode("div", _hoisted_17, [
          (_ctx.uploadStatus === 'checked' || _ctx.uploadStatus === 'imported')
            ? (_openBlock(), _createBlock(_component_a_button, {
                key: 0,
                class: "right-style",
                type: "primary",
                onClick: _ctx.handleBrowse
              }, {
                default: _withCtx(() => [
                  _hoisted_18
                ]),
                _: 1
              }, 8, ["onClick"]))
            : (_openBlock(), _createBlock(_component_a_button, {
                key: 1,
                class: "right-style",
                type: "primary",
                onClick: _ctx.importFile
              }, {
                default: _withCtx(() => [
                  _hoisted_19
                ]),
                _: 1
              }, 8, ["onClick"]))
        ]),
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("div", _hoisted_21, [
            _hoisted_22,
            _createVNode(_component_a_date_picker, {
              style: {"width":"50%"},
              value: _ctx.historyDate,
              "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.historyDate) = $event)),
              "value-format": "YYYY-MM-DD",
              placeholder: "Please select",
              defaultValue: _ctx.rtnCurrendDate(),
              onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.changeEffectiveFrom(_ctx.historyDate)))
            }, null, 8, ["value", "defaultValue"])
          ])
        ]),
        _createElementVNode("div", _hoisted_23, [
          _createVNode(_component_a_table, {
            columns: _ctx.attachmentColumns,
            pagination: false,
            dataSource: _ctx.attachmentData,
            rowKey: "id",
            scroll: { y: 200 },
            rowSelection: _ctx.selection,
            rowClassName: _ctx.getRowClass,
            bordered: ""
          }, {
            action: _withCtx(({ record }) => [
              _createElementVNode("a", null, [
                _createElementVNode("span", {
                  class: "font_family",
                  style: {"font-size":"16px"},
                  onClick: ($event: any) => (_ctx.deleteAttachment(record))
                }, "Delete", 8, _hoisted_24)
              ]),
              _createElementVNode("a", null, [
                _createElementVNode("span", {
                  class: "font_family m-l-20",
                  style: {"font-size":"16px"},
                  onClick: ($event: any) => (_ctx.downloadAttachment(record))
                }, "Download", 8, _hoisted_25)
              ])
            ]),
            _: 1
          }, 8, ["columns", "dataSource", "rowSelection", "rowClassName"])
        ]),
        _createElementVNode("div", _hoisted_26, [
          _createVNode(_component_a_button, {
            style: {"margin-right":"8px"},
            onClick: _ctx.handleCancel
          }, {
            default: _withCtx(() => [
              _hoisted_27
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_a_button, {
            type: "primary",
            onClick: _ctx.updateFunc
          }, {
            default: _withCtx(() => [
              _hoisted_28
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_a_modal, {
      visible: _ctx.downloadModalVisible,
      "onUpdate:visible": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.downloadModalVisible) = $event)),
      "ok-button-props": { disabled: true },
      "cancel-button-props": { disabled: true },
      onOk: _ctx.handleDownload,
      centered: ""
    }, {
      title: _withCtx(() => [
        _createVNode(_component_ExclamationCircleOutlined, { style: {"color":"#faad14"} }),
        _hoisted_29
      ]),
      footer: _withCtx(() => [
        _createVNode(_component_a_button, {
          key: "back",
          onClick: _ctx.cancelTip
        }, {
          default: _withCtx(() => [
            _hoisted_31
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_a_button, {
          key: "submit",
          type: "primary",
          loading: _ctx.loading,
          onClick: _ctx.handleCheckedMsgDownload
        }, {
          default: _withCtx(() => [
            _hoisted_32
          ]),
          _: 1
        }, 8, ["loading", "onClick"])
      ]),
      default: _withCtx(() => [
        _createElementVNode("p", _hoisted_30, _toDisplayString(_ctx.downloadTipsText), 1)
      ]),
      _: 1
    }, 8, ["visible", "onOk"]),
    _createVNode(_component_a_modal, {
      visible: _ctx.emptyVisible,
      "onUpdate:visible": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.emptyVisible) = $event)),
      footer: null,
      centered: ""
    }, {
      title: _withCtx(() => [
        _createVNode(_component_ExclamationCircleOutlined, { style: {"color":"#faad14"} }),
        _hoisted_33
      ]),
      default: _withCtx(() => [
        _createElementVNode("p", _hoisted_34, _toDisplayString(_ctx.emptyTipsText), 1)
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}